import getConditionId from '../../utils/getConditionId';
import EditorConditionRefinement from './EditorConditionRefinement';
import { MEDIA_SIZES, useElementSize } from '../../hooks/useElementSize';
import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import EditorConditionRefinementResponsive from './EditorConditionRefinementResponsive';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EditorConditionRefinementsContainer = ({
  condition,
  filterFamily,
  onConditionChange,
  emptyRefinementConditions,
  conditionPath,
  hasInlineLayout = false
}) => {
  const {
    width
  } = useElementSize();
  const {
    props: {
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  if (emptyRefinementConditions.length === 0) {
    return null;
  }
  const isUsingResponsiveComponent = hasInlineLayout && (width.size === MEDIA_SIZES.md || MEDIA_SIZES.lg);
  const getRefinementContent = emptyRefinementCondition => useOnePanel ? /*#__PURE__*/_jsx(EditorConditionRefinementResponsive, {
    condition: condition,
    filterFamily: filterFamily,
    onConditionChange: onConditionChange,
    emptyRefinementCondition: emptyRefinementCondition
  }) : /*#__PURE__*/_jsx(EditorConditionRefinement, {
    condition: condition,
    filterFamily: filterFamily,
    onConditionChange: onConditionChange,
    emptyRefinementCondition: emptyRefinementCondition
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: emptyRefinementConditions.map((emptyRefinementCondition, index) => {
      const ignoreTopMargin = !useOnePanel && isUsingResponsiveComponent && index === 0;
      return /*#__PURE__*/_jsx(View, {
        marginBlockStart: ignoreTopMargin ? '0' : '300',
        children: getRefinementContent(emptyRefinementCondition)
      }, getConditionId(conditionPath.push(index)));
    })
  });
};
export default EditorConditionRefinementsContainer;